import { render, staticRenderFns } from "./ComponentAccess.vue?vue&type=template&id=2ff81030&scoped=true&"
import script from "./ComponentAccess.vue?vue&type=script&lang=js&"
export * from "./ComponentAccess.vue?vue&type=script&lang=js&"
import style0 from "./ComponentAccess.vue?vue&type=style&index=0&id=2ff81030&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff81030",
  null
  
)

export default component.exports